'use client';
import React, { useEffect, useState } from 'react';
import { Button, Div, Rating, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { ConsultItemsProps } from '../../consults.props';
import Link from 'next/link';
import routes from '@routes';
import getParseRoute from '@utils/helpers/parse-route';
import AppointmentIcon from '@icons-components/appointment-icon';
import ConsultIcon from '@icons-components/consult-icon';
import VideoIcon from '@icons-components/video-icon';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const ConsultItemTablet = (props: ConsultItemsProps) => {
  const [hasConsult, setHasConsult] = useState(false);
  const [hasAppointment, setHasAppointment] = useState(false);
  const { photo, name, title, slug, userServiceFee, rate } = props;
  const { lang } = useParams<{lang: LocaleTypes}>();
  useEffect(() => {
    userServiceFee && userServiceFee.length > 0 && userServiceFee.map((item: any) => {
      if (item?.type_id === 1) {
        setHasAppointment(true);
      }
      if (item?.type_id === 2) {
        setHasConsult(true);
      }
    });
  }, [userServiceFee]);

  return (
    <Div itemScope itemType={'http://schema.org/Physician'} className={'relative pb-4 bg-darkBlue-50 items-center rounded-xl z-[5] mt-12 flex-col'}>
      <Div className={'absolute -top-8'}>
        <Div className={'w-16 h-16 relative object-contain border-2 border-control-200 rounded-full'}>
          <Image itemProp={'image'} sizes={'20vw'} className={'rounded-full'} src={photo} alt={name} fill={true}/>
        </Div>
      </Div>
      <Div className={'relative w-16 h-3 self-center mt-12 items-center justify-center'}>
        <Rating value={parseInt(rate || '5')} readOnly={true}/>
      </Div>
      <Div className={'mt-6 w-full self-center justify-around'}>
        <Button
          ariaLabel={'Appointment'}
          shape={'square'}
          rounded={'full'}
          size={'small'}
          color={'primary'}
          className={'!px-0'}
          disabled={!hasAppointment || true}
          href={hasAppointment ? getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug, id: '1' }, locale: lang }) : '#'}
          startAdornment={<AppointmentIcon/>}
        />
        <Button
          ariaLabel={'Consult'}
          shape={'square'}
          rounded={'full'}
          size={'small'}
          color={'primary'}
          className={'!px-0'}
          disabled={!hasConsult}
          href={hasConsult ? getParseRoute({ pathname: routes['route.consults.dialogue-box'], query: { slug: slug }, locale: lang }) : '#'}
          startAdornment={<ConsultIcon/>}
        />
        <Button
          ariaLabel={'Video Consult'}
          startAdornment={<VideoIcon/>}
          shape={'square'}
          rounded={'full'}
          size={'small'}
          color={'primary'}
          className={'!px-0'}
          disabled={true}
          href={'#'}
        />
      </Div>
      <Div className={'mt-7 items-center flex-col'}>
        <Link passHref={true} href={getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug }, locale: lang })}>
          <Text itemProp={'name'} type={'bold'} color={'grey.900'} className={'w-32 overflow-hidden h-10 whitespace-nowrap text-ellipsis mb-2'}>
            {name}
          </Text>
          <Text itemProp={'description'} typography={'sm'} color={'grey.500'} className={'w-32 overflow-hidden h-6 whitespace-nowrap text-ellipsis mb-2'}>
            {title}
          </Text>
        </Link>
      </Div>
      <Button
        fontType={'bold'}
        href={hasAppointment ? getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug, select: 'دریافت نوبت حضوری', price: '30000 تومان' }, locale: lang }) : '#'}
        disabled={!hasAppointment || true}
        className={'mt-4 w-32'}>
        {props.translate.submit_appointment}
      </Button>
      <Button
        fontType={'bold'}
        href={hasConsult ? getParseRoute({ pathname: routes['route.consults.dialogue-box'], query: { slug: slug }, locale: lang }) : '#'}
        disabled={!hasConsult}
        className={'mt-4 w-32'}>
        {props.translate.consult}
      </Button>
    </Div>
  );
};

export default ConsultItemTablet;
